import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFileAlt,
  faHeading,
  faAlignLeft,
  faCode,
  faTable,
  faColumns,
  faGripLines,
  faImage,
  faSearchPlus,
  faChevronUp,
  faChevronDown,
  faCopy,
  faTrash,
  faTimes,
  faChevronRight,
  faChevronLeft,
  faFileImport,
  faFileExport,
  faFilePdf,
  faFileCode,
  faCube,
  faExclamationCircle,
  faArrowsAltV,
  faFolder,
  faPlus,
  faEllipsisV,
  faArrowUp,
  faArrowDown,
  faExpand,
  faDownload,
  faInfoCircle,
  faExclamationTriangle,
  faCheckCircle,
  faMinus,
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faListUl,
  faListOl,
  faTerminal,
  faEye,
  faExternalLinkAlt,
  faTachometerAlt,
  faTh,
  faShieldAlt,
  faCheck,
  faTag,
  faChartBar,
  faChartLine,
  faChartPie,
  faBullseye,
  faCrosshairs,
  faBorderAll,
  faLayerGroup,
  faChartArea,
  faProjectDiagram,
  faFilter,
  faSignal,
  faThLarge,
  faRandom,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faFileAlt, faHeading, faAlignLeft, faCode, faTable, faColumns,
  faGripLines, faImage, faSearchPlus, faChevronUp, faChevronDown,
  faCopy, faTrash, faTimes, faChevronRight, faChevronLeft,
  faFileImport, faFileExport, faFilePdf, faFileCode, faCube,
  faExclamationCircle, faArrowsAltV, faFolder, faPlus,
  faEllipsisV, faArrowUp, faArrowDown, faExpand, faDownload,
  faInfoCircle, faExclamationTriangle, faCheckCircle, faMinus,
  faBold, faItalic, faUnderline, faStrikethrough, faListUl, faListOl,
  faTerminal, faEye, faExternalLinkAlt,
  faTachometerAlt, faTh, faShieldAlt,
  faCheck, faTag,
  faChartBar, faChartLine, faChartPie, faBullseye, faCrosshairs,
  faBorderAll, faLayerGroup, faChartArea, faProjectDiagram,
  faFilter, faSignal, faThLarge, faRandom,
);
